import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';
import AssociationBoxViewModel from '@/ViewModels/Controls/AssociationBoxViewModel';
import BaseTypeSelectorFactory from '@/Factories/ControlFactories/BaseTypeSelectorFactory';

export default class ACItemUIListener extends UIListener {

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.updateType(context);
    }

    public onAssociationUpdated(context: DetailViewContext, relation: string): void {
        if (relation === 'Type') {
            this.updateType(context);
            this.disconnectObject(context);
        }
    }

    private updateType(context: DetailViewContext): void {
        let associationBoxViewModel = (context.getUIFactory('Type') as ControlFactory).control.context as AssociationBoxViewModel;
        let baseObjectSelectorFactory = context.getUIFactory('Object') as BaseTypeSelectorFactory;

        baseObjectSelectorFactory.pdTypeName = associationBoxViewModel.textBox.value();
    }

    private disconnectObject(context: DetailViewContext): void {
        let baseObjectSelectorFactory = context.getUIFactory('Object') as BaseTypeSelectorFactory;

        baseObjectSelectorFactory.disconnect();
    }
}

ComponentManager.setUIListener('ACItemUIListener', ACItemUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.ACItemUIListener', ACItemUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');